// extracted by extract-css-chunks-webpack-plugin
module.exports = {"subtitle":"subtitle___2E-iV","submit":"submit___36wtp"};